import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    d: "M15.8329 8.4129a1 1 0 0 0-.71-.2958 1 1 0 0 0-.71.2958l-2.29 2.3-2.29-2.3a1.0041 1.0041 0 0 0-1.42 1.42l2.3 2.29-2.3 2.29a1 1 0 0 0-.2958.71 1 1 0 0 0 .2958.71 1 1 0 0 0 .71.2958 1 1 0 0 0 .71-.2958l2.29-2.3 2.29 2.3a1 1 0 0 0 1.42 0 1 1 0 0 0 .2189-.3254 1.002 1.002 0 0 0 0-.7692 1 1 0 0 0-.2189-.3254l-2.3-2.29 2.3-2.29a1 1 0 0 0 .2958-.71 1 1 0 0 0-.2958-.71m3.36-3.36a9.9999 9.9999 0 1 0-14.14 14.14 10.0002 10.0002 0 0 0 17.1925-7.034 10 10 0 0 0-3.0525-7.106m-1.41 12.73a8.0004 8.0004 0 0 1-10.1005 1.0008 8.0001 8.0001 0 0 1 5.9955-14.502 8 8 0 0 1 6.445 7.8412 7.95 7.95 0 0 1-2.34 5.66"
}), "CloseCircle", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
